/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectItemSampleQuery } from '../../models/get-project-item-sample-query';
import { GetProjectItemSampleQueryResult } from '../../models/get-project-item-sample-query-result';

export interface ApiProjectItemSamplesGetProjectItemSamplePost$Plain$Params {
  
    /**
     * The query to retrieve a project item Sample.
     */
    body?: GetProjectItemSampleQuery
}

export function apiProjectItemSamplesGetProjectItemSamplePost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesGetProjectItemSamplePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSampleQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesGetProjectItemSamplePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectItemSampleQueryResult>;
    })
  );
}

apiProjectItemSamplesGetProjectItemSamplePost$Plain.PATH = '/api/ProjectItemSamples/GetProjectItemSample';
